<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">{{!selectCampoAdicional ? 'Agregar' : 'Editar'}} Campo Adicional</label>
      </header>
      <form [formGroup]="formCampoAdicional" (ngSubmit)="onOperarCampoAdicional()">
        <div class="form-group">
          <label class="small text-secondary" for="nit">Tipo de dato</label>
          <select class="form-control form-control-sm"
          id="tipo_dato_id"
          formControlName="tipo_dato_id"
          (change)="tipoDatoMultiple($event)">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" *ngFor="let option of tipoDato; let i = index" value="{{option?.tipo_dato_id}}"
              [selected]="false">
              {{option?.descripcion}}
            </option>
          </select>
        </div>
        <div id="containerPreguntasMultiples" class="d-none">
          <ul class="list-group" id="listaRespuesta">
            <li class="list-group-item" id="respuesta_{{item.index}}" *ngFor="let item of listadoRespuesta">
              <div class="row">
                <div class="col-md-3">
                  Rpta. {{ item.index }}
                </div>
                <div class="col-md-7">
                  <input type="text" class="form-control" name="inputRespuestas[]" [value]="item.respuesta">
                </div>
                <div class="col-md-2">
                  <img src="../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25"
                    (click)="eliminarRespuesta(item.index)">
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-md-12 text-center">
                  <button type="button" class="btn btn-secondary btn-sm" (click)="agregarRespuesta()">
                    Agregar respuesta
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="form-group" *ngIf="formCampoAdicional.controls.tipo_dato_id.value == multipleFeatureId">
          <div class="multiple-option" *ngFor="let multipleFeature of formCampoAdicional.controls.caracateristicas_opciones.value; let i = index;">
            <div id="{{i}}">
              <div class="multiple-header">
                <div class="multiple-title">
                  <label class="small text-secondary" for="nit">Título</label>
                </div>
                <div class="multiple-delete-icon" (click)="removeMultipleFeature( i )">
                  <mat-icon class="multiple-delete-icon">delete</mat-icon>
                </div>
              </div>
              <div>
                <input placeholder="Escriba aquí el titulo del campo"
                type="text" name="descripcion" [value]="multipleFeature.descripcion"
                class="form-control form-control-sm form-margin" (change)="multipleFeatureChange( $event, i )">
                <select class="form-control form-control-sm" name="caracteristicas_opciones_id"
                [value]="multipleFeature.caracteristicas_opciones_id" (change)="multipleFeatureChange( $event, i )">
                  <option [ngValue]="null" selected="true">
                    {{ (multipleFeature.caracteristicas_opciones_id)
                      ? multipleFeature.caracteristicas_opciones_descripcion
                      : 'Seleccione'}}
                  </option>
                  <option *ngFor="let option of multipleFeatureData; let i = index" [value]="option?.caracteristicas_opciones_id"
                    [selected]="false" [id]="i">
                    {{option?.descripcion}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <button mat-button class="multiple-btn" type="button" (click)="multipleNewInput()">Crear nuevo campo</button>
        </div>

        <div class="form-group">
          <label class="small text-secondary" for="nit">Descripción</label>
          <input id="descripcion" formControlName="descripcion" type="text" class="form-control form-control-sm">
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Título</label>
          <input id="titulo" formControlName="titulo" type="text" class="form-control form-control-sm">
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Obligatorio</label>
          <select class="form-control form-control-sm" id="es_obligatorio" formControlName="es_obligatorio">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Sí
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              No
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Tipo de prestador</label>
          <div class="commercial-container">
            <mat-checkbox color="primary" (change)="commercialResult( $event.checked, 'aplica_comerciante' )" formControlName="aplica_comerciante">
              <label class="small text-secondary category-check" for="nit">Se muestra para Comerciante</label>
            </mat-checkbox>
            <mat-checkbox color="primary" (change)="commercialResult( $event.checked, 'aplica_no_comerciante' )" formControlName="aplica_no_comerciante">
              <label class="small text-secondary category-check" for="nit">Se muestra para No comerciante</label>
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Estado</label>
          <select class="form-control form-control-sm" id="activo" formControlName="activo"
            [attr.disabled]="!selectCampoAdicional ? '' : null">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Activo
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              Inactivo
            </option>
          </select>
        </div>
        <div class="form-row mt-5">
          <button type="button" class="btn btn-outline-primary border-0 m-auto"
            (click)="limpiarCampoAdicional()">Limpiar</button>
          <button class="btn btn-primary m-auto"
            [disabled]="!formCampoAdicional.valid || !multipleFeatureValidation()" type="submit">{{!selectCampoAdicional
            ? 'Agregar' : 'Editar'}}</button>
        </div>
      </form>
    </section>
    <!-- Tbl, listado de la data -->
    <section class="col-9 p-4 mt-5 mb-5">
      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Listado Campos Adicionales</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>
      <!-- Filtros -->
      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Tipo de dato</label>
                  <select class="form-control form-control-sm" id="tipo_dato_id" formControlName="tipo_dato_id">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of tipoDato; let i = index" value="{{option?.tipo_dato_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Descripción</label>
                  <input id="descripcion" formControlName="descripcion" type="text"
                    class="form-control form-control-sm">
                </div>
                <div class="form-group">
                  <label class="small text-secondary" for="nit">Título</label>
                  <input id="titulo" formControlName="titulo" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Obligatorio</label>
                  <select class="form-control form-control-sm" id="es_obligatorio" formControlName="es_obligatorio">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Estado</label>
                  <select class="form-control form-control-sm" id="activo" formControlName="activo">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Activo
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Inactivo
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto"
                    (click)="limpiar()">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <app-tablas [page] = "paginaActual" [headers]="headerCampoAdicional" [sizeData]="dataTabla.paging.totalItems"
          (paginado)="onPaginado($event)" class="table-responsive">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.campo_adicional_id}}</td>
            <td>{{item.descripcion}}</td>
            <td>{{item.descripcion_tipo_dato}}</td>
            <td>{{item.es_obligatorio ? 'Sí' : 'No'}}</td>
            <td>{{item.titulo}}</td>
            <td>{{item.activo ? 'Activo' : 'Inactivo'}}</td>
            <td class="d-flex flex-row">
              <img *ngIf="item.tipo_dato_id === multipleId" src="../../../../../../../assets/icons/associate.png" class="pointer" alt="" height="25"
                (click)="openAssociateQuestions(item)">
              <img src="../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25"
                (click)="onCargarCampoAdicional(item)">
              <img src="../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25"
                (click)="onEliminarCampoAdicional(item)">
            </td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>
